angular.module('component-payments.format.expire.month.text', [])
	.directive('ctPaymentsFormatExpireMonthText', paymentsFormatMonthDirective);

paymentsFormatMonthDirective.$inject = ['CtUtils'];
function paymentsFormatMonthDirective(CtUtils) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: postLink
	};

	function postLink(scope, element, attr, ctrl) {
		element.on('keypress', onKeyPress);

		ctrl.$parsers.push(parser);

		function parser(value) {
			if (parseInt(value) > 12)
				value = '12';

			ctrl.$setViewValue(value);
			ctrl.$render();

			return value;
		}

		function onKeyPress(e) {
			var char = CtUtils.getChar(e);

			if (!char.match(/./)) {
				return;
			}

			if (!char.match(/\d/)) {
				e.preventDefault();
			}
		}
	}
}

module.exports = 'component-payments.format.expire.month.text';




/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/month-text.js
 ** module id = 91
 ** module chunks = 1
 **/